// extracted by mini-css-extract-plugin
export default {"custom-header-bg":"open-prods_custom-header-bg__hG5MF"};